/**
 * توابع کمکی برای پردازش داده‌های گزارش کارکرد
 */

/**
 * فیلتر کردن داده‌ها برای نمایش فقط آخرین لاگ هر کار
 */
export const filterLatestLogs = (data: any[], showOnlyLatestLogs: boolean) => {
  // بررسی اینکه data یک آرایه است
  if (!Array.isArray(data)) {
    console.warn("filterLatestLogs: data is not an array", data);
    return [];
  }

  if (!showOnlyLatestLogs) return data;

  const taskGroups = new Map();
  const followupGroups = new Map();

  data.forEach((item) => {
    if (item.taskTitle) {
      // گروه‌بندی بر اساس شناسه وظیفه
      const key = item.taskId || item.taskRef || item.taskTitle;
      if (
        !taskGroups.has(key) ||
        new Date(item.createdOn) > new Date(taskGroups.get(key).createdOn)
      ) {
        taskGroups.set(key, item);
      }
    } else if (item.followupTitle) {
      // گروه‌بندی بر اساس شناسه پیگیری
      const key = item.followupId || item.followupRef || item.followupTitle;
      if (
        !followupGroups.has(key) ||
        new Date(item.createdOn) > new Date(followupGroups.get(key).createdOn)
      ) {
        followupGroups.set(key, item);
      }
    }
  });

  // ترکیب نتایج
  return [...taskGroups.values(), ...followupGroups.values()];
};

/**
 * گروه‌بندی داده‌ها بر اساس عنوان وظیفه/پیگیری
 */
export const groupDataByTitle = (
  data: any[],
  showOnlyLatestLogs: boolean,
  userId: string,
  userName: string
) => {
  // بررسی اینکه data یک آرایه است
  if (!Array.isArray(data)) {
    console.warn("groupDataByTitle: data is not an array", data);
    return [];
  }

  // ابتدا فیلتر آخرین لاگ‌ها را اعمال کن
  const filteredData = filterLatestLogs(data, showOnlyLatestLogs);

  // بررسی مجدد که filteredData یک آرایه است
  if (!Array.isArray(filteredData)) {
    console.warn(
      "groupDataByTitle: filteredData is not an array",
      filteredData
    );
    return [];
  }

  const grouped = filteredData.reduce((acc, item) => {
    const title = item.taskTitle || item.followupTitle || "نامشخص";

    if (!acc[title]) {
      acc[title] = [];
    }
    acc[title].push(item);
    return acc;
  }, {} as Record<string, any[]>);

  const result = Object.entries(grouped).map(([title, items]) => ({
    title,
    items: items as any[],
    count: (items as any[]).length,
  }));

  // لاگ گروه‌بندی داده‌ها
  console.log(`📊 WorkReport Data Grouped:`, {
    timestamp: new Date().toISOString(),
    userId,
    userName,
    originalDataLength: data.length,
    filteredDataLength: filteredData.length,
    groupsCount: result.length,
    showOnlyLatestLogs,
    groupedBy: result.map((g) => ({ title: g.title, count: g.count })),
  });

  return result;
};
